module.exports = __webpack_public_path__ + "static/media/uib1.87be2251.png";